import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './AssetRibbon.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from 'react';
import { Tooltip } from 'antd';

type Props = {
  tooltip: React.ReactNode;
  icon: IconDefinition;
  color: string;
}

export default memo(({ tooltip, icon, color }: Props) => (
  <Tooltip title={tooltip}>
    <div className={`ribbon shadow bg-${color} text-${color}`}>
      <FontAwesomeIcon icon={icon} className="text-white" />
    </div>
  </Tooltip>
))